export const AUTH_REQUEST = 'authRequest';
export const AUTH_SUCCESS = 'authSuccess';
export const AUTH_ERROR = 'authError';
export const USER_REQUEST = 'userRequest';
export const USER_SUCCESS = 'userSuccess';
export const USER_ERROR = 'userError';
export const SET_USERNAME = 'setUsername';
export const SET_USER_ID = 'setUserId';
export const REFRESH_REQUEST = 'refreshRequest';
export const LOGOUT = 'logout';
export const LOGOUT_SUCCESS = 'logoutSuccess';
export const REGISTER = 'register';
export const CONFIRM_EMAIL = 'confirmEmail';
export const CONFIRM_EMAIL_SUCCESS = 'confirmEmailSuccess';
export const CONFIRM_EMAIL_ERROR = 'confirmEmailError';
export const CONFIRM_EMAIL_LOADING = 'confirmEmailLoading';
export const FORGOT_PASSWORD = 'forgotPassword';
export const FORGOT_PASSWORD_SUCCESS = 'forgotPasswordSuccess';
export const FORGOT_PASSWORD_LOADING = 'forgotPasswordLoading';
export const FORGOT_PASSWORD_ERROR = 'forgotPasswordError';
export const POST_NEW_PASSWORD = 'postNewPassword';
export const POST_NEW_PASSWORD_SUCCESS = 'postNewPasswordSuccess';
export const POST_NEW_PASSWORD_LOADING = 'postNewPasswordLoading';
export const POST_NEW_PASSWORD_ERROR = 'postNewPasswordError';
export const USER_ROLES_REQUEST = 'userRolesRequest';
export const SET_USER_ROLES = 'setUserRoles';
export const SET_PASSWORD = 'setPassword';
export const FETCH_SECURITY_QUESTIONS = 'fetchSecurityQuestions';
export const FETCH_USER_APP = 'fetchUserApp';
export const SET_CPA_ID = 'setCPAId';
